<template>
  <div class="container-fluid NavAttract-container fade-in">
    <div class="justify-content-md-center justify-content-lg-end NavAttract-wrapper row">
      <div class="col-md-10 col-lg-6 col-xl-5 mr-xl-2 NavAttract">
        <h1 class="NavAttract-title mb-1 text-center">The Hidden Life of Wolves</h1>
        <p class="font-italic mb-3 NavAttract-subtitle text-center">An interactive exhibit</p>

        <h4 class="text-center">Presented by <a href="https://www.livingwithwolves.org/" class="LinkInline" target="_blank" rel="noopener"><img src="./../../../static/images/lww-logo.png" alt="Living with Wolves" class="Logo"></a></h4>

        <ul class="NavAttract-menu">
          <li
          class="NavAttract-menu-item"
          v-for="(link, i) in siteConfig.navigation" 
          :key="i"
          @click="updateState(link, 'fade')">
            <router-link :to="link.slug">{{ link.title }}</router-link>
          </li>
          <li class="NavAttract-menu-item">
            <a href="https://livingwithwolves.org">Home</a>
          </li>
        </ul>
        <p>Join us in exploring the secrets of one of the world’s most social, intelligent, and misunderstood animals.</p>
        <p>For millennia, gray wolves, <em>Canis lupus</em>, and humans lived side by side often learning and benefitting from one another. Domestic dogs, <em>Canis lupus familiaris</em>, are directly descended from wolves. Their innate, devotion, affection, and commitment to family came from their wild wolf ancestors. Once roaming much of the Northern Hemisphere, wolves have been reduced to trace populations, clinging to survival in parts of their former range.</p>
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from './../../../static/data/site-config.json'
export default {
  data () {
    return {
      siteConfig
    }
  },

  methods: {
    updateState (link, animation) {
      let parent = link.defaultView.parent
      let view = link.defaultView.view
      let payload = {
        parent: parent,
        updates: {
          currentDetail: null,
          currentView: view,
          animation: animation || 'fade'
        }
      }
      if (parent && view !== '') {
        this.$store.dispatch('updateProps', payload)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';

.logo {
  display: block;
  margin: auto;
  max-width: 450px;
}

.NavAttract-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  opacity: 0;
  min-height: 100vh;
  @media screen and (min-width: $grid-md) {
    height: 100vh;
  }
}

.NavAttract {
  background-color: $transparentDarkgray;
  color: $offwhite;
  font-family: $fontSansSerif;
  padding: 3em;
  & p:last-child {
    margin-bottom: 0;
  }
}

.NavAttract-intro {
  line-height: 1.75em;
  margin: 1em 0 .5em 0;
}

.NavAttract-menu {
  border-bottom: 2px solid $gold;
  display: flex;
  flex-wrap: wrap;
  font-family: $fontSansSerif;
  font-size: .9em;
  // font-weight: bold;
  justify-content: space-between;
  line-height: 2.5em;
  list-style-type: none;
  margin: 1em 0 2em 0;
  padding: 0 0 .5em 0;
  text-transform: uppercase;
}

.NavAttract-menu-item {
  display: inline-block;
  margin: 0 1em 0 0;
  a {
    transition: $transitionHover;
    &:hover {
      color: $gold;
    }
  }
  &:last-child  {
    margin: 0;
  }
}

.NavAttract-title {
  font-size: 2.5rem;
}

.NavAttract-subtitle {
  font-size: 1.5rem;
}

.NavAttract-wrapper {
  justify-content: flex-end;
  @media screen and (min-width: $grid-md) {
    margin-top: 20vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/navAttract.vue